import PastOrders from "./PastOrders.view";

export default PastOrders;
